import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { type MatMenu } from '@angular/material/menu';
import { buildIntercomTarget } from '@principle-theorem/ng-intercom';
import {
  SidebarManagerService,
  TrackByFunctions,
} from '@principle-theorem/ng-shared';
import { Region, getEnumValues, snapshot } from '@principle-theorem/shared';
import { type ISidebarItem } from '../sidebar-item';

interface IRoutePath {
  routePrefix: string;
  link: ISidebarItem;
}

@Component({
  selector: 'pr-sidebar-group',
  templateUrl: './sidebar-group.component.html',
  styleUrls: ['./sidebar-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidebarGroupComponent {
  trackByLink = TrackByFunctions.label<ISidebarItem>();
  allRegions = getEnumValues(Region);
  @Input() label = '';
  @Input() tooltip = '';
  @Input() links: ISidebarItem[] = [];
  @Input() expanded = false;
  @Input() matMenu?: MatMenu;
  @Input() matMenuTooltip?: string;
  @Input() routePrefix: string = '';

  constructor(private _sidebar: SidebarManagerService) {}

  getRoutePath({ routePrefix, link }: IRoutePath): string {
    return routePrefix.endsWith('/')
      ? `${routePrefix.slice(0, -1)}/${link.path}`
      : `${routePrefix}/${link.path}`;
  }

  async closeSidebarIfMobile(): Promise<void> {
    const isMobile = await snapshot(this._sidebar.isMobile$);
    if (isMobile) {
      this._sidebar.close();
    }
  }

  getIntercomTarget(link: ISidebarItem): string {
    return buildIntercomTarget(['sidebar', this.label, link.label]);
  }
}
